import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { loadTheme } from 'office-ui-fabric-react/lib/Styling';
import React, { Component, Fragment } from 'react';
import { NotificationsTarget } from '../../contexts/notificationContext';
//import PerimetreContext from '../../contexts/PerimetreContext';
import { Header } from './Header';
import MainProgressIndicator from './MainProgressIndicator';
import MessageBars from './MessageBars';
import { Perimetre } from './Perimetre';

// Th�me Eiffage
loadTheme({
    palette: {
        themePrimary: '#fd0400',
        themeLighterAlt: '#fff5f5',
        themeLighter: '#ffd7d6',
        themeLight: '#feb3b2',
        themeTertiary: '#fd6865',
        themeSecondary: '#fd221e',
        themeDarkAlt: '#e30400',
        themeDark: '#c00300',
        themeDarker: '#8d0200',
        neutralLighterAlt: '#f8f8f8',
        neutralLighter: '#f4f4f4',
        neutralLight: '#eaeaea',
        neutralQuaternaryAlt: '#dadada',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c8c8',
        neutralTertiary: '#c2c2c2',
        neutralSecondary: '#858585',
        neutralPrimaryAlt: '#4b4b4b',
        neutralPrimary: '#333333',
        neutralDark: '#272727',
        black: '#1d1d1d',
        white: '#ffffff',
    }
});

// KP - 02/01/2024 : rechargement du p�rim�tre via localStorage remplac� par context
export class Layout extends Component {

    //static contextType = PerimetreContext;

    constructor(props) {
        super(props);
        this.state = { perimetreChange: false };
    };

    //_onPerimetreChange = () => {
    //    this.setState({ perimetreChange: true });
    //};

    //_onReinitPerimetreChange = () => {
    //    if (this.state.perimetreChange) {
    //        this.setState({ perimetreChange: false });
    //    }
    //};

    render = () => {

        //const { perimetreChange } = this.state;

        //*********************************************************************************
        //ne marche pas => on met dans le localstorage afin de le r�cup�rer dans les childrens pour savoir si on met � jour notre donn�e
        //let children = React.Children.map(
        //    this.props.children,
        //    child => React.cloneElement(child, { onRecharge: perimetreChange }, null)
        //);
        //*********************************************************************************

        //localStorage.setItem("onRecharge", perimetreChange);

        return <Fragment>
            <Stack verticalFill>
                <Header /> {/*onPerimetreChange={perimetreChange} onReinitPerimetreChange={this._onReinitPerimetreChange} />*/}
                <Perimetre /> {/*onPerimetreChange={this._onPerimetreChange} />*/}
                <MessageBars target={NotificationsTarget.main} />
                {this.props.children}
            </Stack>
            <MainProgressIndicator />
        </Fragment>;

    };

};